/* Serune theme — ambient nocturnal effects + light UI.
   Runs after DOM parse (loaded with defer). */
(function () {
  "use strict";
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches;

  /* gold starfield — any <canvas class="stars"> fills its positioned parent */
  document.querySelectorAll("canvas.stars").forEach(function (c) {
    var h = c.parentElement;
    function size() { c.width = h.offsetWidth; c.height = h.offsetHeight; }
    size();
    var x = c.getContext("2d"), N = Math.min(110, Math.round(c.width / 16)), st = [];
    for (var i = 0; i < N; i++) {
      st.push({ x: Math.random() * c.width, y: Math.random() * c.height * 0.82,
        r: Math.random() * 1.3 + 0.3, a: Math.random() * 0.5 + 0.15, tw: Math.random() * 0.02 + 0.004, p: Math.random() * 6 });
    }
    function paint(dyn) {
      x.clearRect(0, 0, c.width, c.height);
      for (var i = 0; i < N; i++) {
        var s = st[i], a = dyn ? s.a * (0.6 + 0.4 * Math.sin(s.p += s.tw)) : s.a;
        x.beginPath(); x.arc(s.x, s.y, s.r, 0, 7); x.fillStyle = "rgba(214,180,110," + a + ")"; x.fill();
      }
      if (dyn) requestAnimationFrame(function () { paint(true); });
    }
    /* PERF 2026-07-08: static starfield — paint once, no rAF loop (removes
       continuous main-thread work). Revert: paint(!reduce) + "if (reduce)" guard below. */
    paint(false);
    window.addEventListener("resize", function () { size(); paint(false); });
  });

  /* cacao dust — scatter flecks into <div class="dust"> */
  document.querySelectorAll(".dust").forEach(function (d) {
    var pts = [[8,10,2.4],[16,22,1.5],[26,6,1.8],[38,26,1.2],[55,14,2.2],[64,30,1.4],[72,8,1.7],[80,24,2],[88,16,1.3],[94,28,1.6],[46,4,1.4],[34,18,1.1]];
    pts.forEach(function (p) {
      var i = document.createElement("i");
      i.style.left = p[0] + "%"; i.style.top = p[1] + "px";
      i.style.width = p[2] + "px"; i.style.height = p[2] + "px";
      i.style.opacity = (0.25 + Math.random() * 0.4);
      d.appendChild(i);
    });
  });

  /* PERF 2026-07-08: removed the legacy [data-quiz] stepper that lived here.
     The live quiz logic is self-contained in sections/symptom-quiz.liquid; this
     old handler advanced on any .opt click and collided with it (it was the
     "phantom" advancer behind the multi-select bug). Revert: restore this block. */

  /* PERF 2026-07-08: ambient CSS loops (sheen, steam) start only after load so
     they do not weigh on first paint / Lighthouse; see base.css .is-loaded rules.
     Revert: delete this block and the base.css .is-loaded rules. */
  function ambientOn() { document.body.classList.add("is-loaded"); }
  if (document.readyState === "complete") setTimeout(ambientOn, 200);
  else window.addEventListener("load", function () { setTimeout(ambientOn, 200); });
})();
